import React, { PureComponent } from 'react';
import { bool, func, number, object, string } from 'prop-types';
import isNil from 'ramda/src/isNil';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import queryString from 'query-string';
import { Image } from 'mangools-react-components/src';

import { MOBILE } from 'mangools-commons/dist/constants/Platforms';
import Defaults from 'mangools-commons/dist/constants/Defaults';
import Urls from 'mangools-commons/dist/constants/Urls';

import serpcheckerIcon from 'images/serpchecker-icon.svg';
import sadImg from 'images/sad.svg';
import sadImgDark from 'images/sad-dark.svg';
import { IS_CUSTOM_DOMAIN } from 'constants/isCustomDomain';
import Tooltip from 'components/other/Tooltip';
import SerpPreviewFrame, { SERP_PREVIEW_STATUS } from 'components/modals/tracking/SerpPreviewFrame';

const SERP_MODAL_CONTAINER_ID = 'SERP_MODAL_CONTAINER_ID';
// Stored SERPs are deleted after 60 days; the API flags an older day with serp_snapshot.expired.
const SERP_RETENTION_DAYS = 60;

class SerpModal extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            previewStatus: SERP_PREVIEW_STATUS.LOADING,
        };

        this.isMobile = this.isMobile.bind(this);
        this.handleModalClick = this.handleModalClick.bind(this);
        this.handleOpenInSerpchecker = this.handleOpenInSerpchecker.bind(this);
        this.handlePreviewStatusChange = this.handlePreviewStatusChange.bind(this);
        this.renderLoader = this.renderLoader.bind(this);
        this.renderPreviewUnavailable = this.renderPreviewUnavailable.bind(this);
        this.handleSaveImage = this.handleSaveImage.bind(this);
    }

    handlePreviewStatusChange(previewStatus) {
        this.setState({ previewStatus });
    }

    isMobile() {
        return this.props.platformId === MOBILE.id;
    }

    handleOpenInSerpchecker(e) {
        e.preventDefault();

        const query = queryString.stringify({
            keyword: this.props.keyword,
            location: this.props.locationId,
            platform: this.props.platformId,
            ref: 'serp-modal-app-sw',
        });

        const url = `${Urls.SERPCHECKER_APP_URL}/dashboard?${query}`;
        window.open(url, '_blank');
    }

    handleModalClick(e) {
        if (e.target.id === SERP_MODAL_CONTAINER_ID) {
            e.stopPropagation();
            this.props.onClose();
        }
    }

    handleSaveImage() {
        this.props.requestSnapshotImage();
    }

    /* eslint-disable max-len */
    renderLoader() {
        if (this.state.previewStatus === SERP_PREVIEW_STATUS.LOADING) {
            if (this.isMobile()) {
                return (
                    <div
                        className="uk-position-top-center uk-positon-z-index bg-fff"
                        style={{ height: '540px', width: '326px', overflow: 'hidden', top: '55px' }}
                    >
                        <div className="bg-grey mg-padding-15">
                            <div className="bg-fff uk-width-1-1" style={{ height: '30px' }} />
                        </div>
                        <div className="mg-border-b mg-padding-15  bg-fff">
                            <div className="uk-grid">
                                <div className="uk-width-2-10">
                                    <div className="mg-preloader-block uk-width-1-1" style={{ height: '14px' }} />
                                </div>
                                <div className="uk-width-2-10">
                                    <div className="mg-preloader-block uk-width-1-1" style={{ height: '14px' }} />
                                </div>
                                <div className="uk-width-2-10">
                                    <div className="mg-preloader-block uk-width-1-1" style={{ height: '14px' }} />
                                </div>
                            </div>
                        </div>
                        <div className="ln-11 bg-fff mg-padding-15">
                            <div className="mg-margin-b-30">
                                <div className="mg-preloader-block uk-width-2-3" style={{ height: '16px' }} />
                                <div className="mg-preloader-block uk-width-3-4" style={{ height: '16px' }} />
                                <div className="mg-preloader-block uk-width-8-10" style={{ height: '12px' }} />
                                <div className="mg-preloader-block uk-width-6-10" style={{ height: '10px' }} />
                                <div className="mg-preloader-block uk-width-7-10" style={{ height: '10px' }} />
                            </div>
                            <div className="mg-margin-b-30">
                                <div className="mg-preloader-block uk-width-2-3" style={{ height: '16px' }} />
                                <div className="mg-preloader-block uk-width-3-4" style={{ height: '16px' }} />
                                <div className="mg-preloader-block uk-width-8-10" style={{ height: '12px' }} />
                                <div className="mg-preloader-block uk-width-6-10" style={{ height: '10px' }} />
                                <div className="mg-preloader-block uk-width-7-10" style={{ height: '10px' }} />
                            </div>
                            <div className="mg-margin-b-30">
                                <div className="mg-preloader-block uk-width-2-3" style={{ height: '16px' }} />
                                <div className="mg-preloader-block uk-width-3-4" style={{ height: '16px' }} />
                                <div className="mg-preloader-block uk-width-8-10" style={{ height: '12px' }} />
                                <div className="mg-preloader-block uk-width-6-10" style={{ height: '10px' }} />
                                <div className="mg-preloader-block uk-width-7-10" style={{ height: '10px' }} />
                            </div>
                        </div>
                    </div>
                );
            } else {
                return (
                    <div
                        className="uk-position-cover uk-position-z-index mg-card"
                        style={{ height: '90vh', overflow: 'hidden' }}
                    >
                        <div className="bg-dark" style={{ height: '28px' }} />
                        <div className="bg-grey mg-padding-30-0">
                            <div className="bg-fff" style={{ height: '30px', marginLeft: '132px', width: '555px' }} />
                        </div>
                        <div className="mg-border-b mg-padding-15-0">
                            <div className="uk-grid" style={{ width: '900px', marginLeft: '97px' }}>
                                <div className="uk-width-1-10">
                                    <div className="mg-preloader-block uk-width-1-1" style={{ height: '14px' }} />
                                </div>
                                <div className="uk-width-1-10">
                                    <div className="mg-preloader-block uk-width-1-1" style={{ height: '14px' }} />
                                </div>
                                <div className="uk-width-1-10">
                                    <div className="mg-preloader-block uk-width-1-1" style={{ height: '14px' }} />
                                </div>
                                <div className="uk-width-1-10">
                                    <div className="mg-preloader-block uk-width-1-1" style={{ height: '14px' }} />
                                </div>
                                <div className="uk-width-1-10">
                                    <div className="mg-preloader-block uk-width-1-1" style={{ height: '14px' }} />
                                </div>
                                <div className="uk-width-1-10">
                                    <div className="mg-preloader-block uk-width-1-1" style={{ height: '14px' }} />
                                </div>
                            </div>
                        </div>
                        <div className="uk-flex mg-margin-t-30 ln-11">
                            <div style={{ width: '700px', marginLeft: '132px' }}>
                                <div className="mg-margin-b-30">
                                    <div className="mg-preloader-block uk-width-2-3" style={{ height: '16px' }} />
                                    <div className="mg-preloader-block uk-width-3-4" style={{ height: '16px' }} />
                                    <div className="mg-preloader-block uk-width-8-10" style={{ height: '12px' }} />
                                    <div className="mg-preloader-block uk-width-6-10" style={{ height: '10px' }} />
                                    <div className="mg-preloader-block uk-width-7-10" style={{ height: '10px' }} />
                                </div>
                                <div className="mg-margin-b-30">
                                    <div className="mg-preloader-block uk-width-2-3" style={{ height: '16px' }} />
                                    <div className="mg-preloader-block uk-width-3-4" style={{ height: '16px' }} />
                                    <div className="mg-preloader-block uk-width-8-10" style={{ height: '12px' }} />
                                    <div className="mg-preloader-block uk-width-6-10" style={{ height: '10px' }} />
                                    <div className="mg-preloader-block uk-width-7-10" style={{ height: '10px' }} />
                                </div>
                                <div className="mg-margin-b-30">
                                    <div className="mg-preloader-block uk-width-2-3" style={{ height: '16px' }} />
                                    <div className="mg-preloader-block uk-width-3-4" style={{ height: '16px' }} />
                                    <div className="mg-preloader-block uk-width-8-10" style={{ height: '12px' }} />
                                    <div className="mg-preloader-block uk-width-6-10" style={{ height: '10px' }} />
                                    <div className="mg-preloader-block uk-width-7-10" style={{ height: '10px' }} />
                                </div>
                                <div className="mg-margin-b-30">
                                    <div className="mg-preloader-block uk-width-2-3" style={{ height: '16px' }} />
                                    <div className="mg-preloader-block uk-width-3-4" style={{ height: '16px' }} />
                                    <div className="mg-preloader-block uk-width-8-10" style={{ height: '12px' }} />
                                    <div className="mg-preloader-block uk-width-6-10" style={{ height: '10px' }} />
                                    <div className="mg-preloader-block uk-width-7-10" style={{ height: '10px' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }
        } else {
            return null;
        }
    }
    /* eslint-enable max-len */

    renderPreviewUnavailable() {
        const isMobile = this.isMobile();
        const { serpExpired } = this.props;
        const keyword = <strong className="color-black">{this.props.keyword}</strong>;
        const previewDate = <strong className="color-black uk-text-nowrap">{this.props.previewDate}</strong>;

        return (
            <div className="snapshot-unavailable-screen">
                <div className="snapshot-unavailable" role="status">
                    <Image
                        className={isMobile ? 'mg-margin-b-15' : 'mg-margin-b-30'}
                        colorScheme={this.props.colorScheme}
                        darkSrc={sadImgDark}
                        lightSrc={sadImg}
                        width={isMobile ? '100' : '140'}
                    />
                    <h2 className={classnames('uk-text-bold mg-margin-b-15', isMobile ? 'font-21' : 'font-24')}>
                        {serpExpired ? 'This SERP is no longer stored' : "Sorry, the SERP couldn't be downloaded"}
                    </h2>
                    <p
                        className={classnames('color-grey', {
                            'font-14': isMobile,
                            'mg-margin-b-15': IS_CUSTOM_DOMAIN && !serpExpired,
                            'uk-margin-bottom-remove': IS_CUSTOM_DOMAIN && serpExpired,
                            'mg-margin-b-30': !IS_CUSTOM_DOMAIN,
                        })}
                    >
                        {serpExpired ? (
                            <>
                                We keep SERP snapshots for {SERP_RETENTION_DAYS} days, and the one for {keyword} on{' '}
                                {previewDate} is older than that. To preview a SERP, pick a date range that ends within
                                the last {SERP_RETENTION_DAYS} days.
                            </>
                        ) : (
                            <>
                                We couldn&apos;t load the saved Google results for {keyword} from {previewDate}.
                            </>
                        )}
                    </p>
                    {IS_CUSTOM_DOMAIN ? (
                        // The expired text already says which date range to pick.
                        !serpExpired && (
                            <p className="font-14 color-grey uk-margin-bottom-remove">
                                Try a different date range to preview another day.
                            </p>
                        )
                    ) : (
                        <>
                            <button
                                className="mg-btn is-blue is-small"
                                onClick={this.handleOpenInSerpchecker}
                                type="button"
                            >
                                <img
                                    alt=""
                                    className="mg-margin-r-5"
                                    src={serpcheckerIcon}
                                    style={{ marginTop: '-2px' }}
                                    width="10"
                                />
                                Open in SERPChecker
                            </button>
                            <p className="font-12 color-grey mg-margin-t-10 uk-margin-bottom-remove">
                                Opens today&apos;s live SERP, which may differ from{' '}
                                <span className="uk-text-nowrap">{this.props.previewDate}</span>.
                            </p>
                        </>
                    )}
                </div>
            </div>
        );
    }

    render() {
        if (this.props.visible) {
            const hasValidSerpUrl = !isNil(this.props.serpUrl) && this.props.serpUrl !== Defaults.NOT_AVAILABLE;
            const previewUnavailable = !hasValidSerpUrl || this.state.previewStatus === SERP_PREVIEW_STATUS.FAILED;

            const iframeClasses = classnames({
                'snapshot-frame': true,
                'is-mobile': this.isMobile(),
            });

            const modalClasses = classnames('uk-modal', 'uk-display-block', {
                'uk-open': this.props.visible,
                'is-mobile': this.isMobile(),
            });

            const modalContenClasses = classnames('mg-modal-content', 'uk-padding-remove', {
                'bg-dark': this.isMobile() === false,
            });

            return (
                <div id={SERP_MODAL_CONTAINER_ID} className={modalClasses} onClick={this.handleModalClick}>
                    <div className="uk-modal-dialog is-large uk-padding-remove">
                        <button
                            aria-label="Close"
                            className="mg-close"
                            onClick={this.props.onClose}
                            style={{ zIndex: '2' }}
                            type="button"
                        >
                            <FontAwesomeIcon icon="times" aria-hidden="true" />
                        </button>
                        <div className={modalContenClasses} style={{ maxHeight: 'unset' }}>
                            <div className="uk-position-relative uk-flex uk-flex-center">
                                {hasValidSerpUrl ? (
                                    <SerpPreviewFrame
                                        className={iframeClasses}
                                        key={this.props.serpUrl}
                                        onStatusChange={this.handlePreviewStatusChange}
                                        title={`SERP view for ${this.props.keyword}`}
                                        url={this.props.serpUrl}
                                    >
                                        {this.renderPreviewUnavailable()}
                                    </SerpPreviewFrame>
                                ) : (
                                    <div className={iframeClasses}>{this.renderPreviewUnavailable()}</div>
                                )}
                                {hasValidSerpUrl && this.renderLoader()}
                            </div>
                        </div>
                        <div className="mg-modal-footer uk-text-center">
                            {!IS_CUSTOM_DOMAIN && !previewUnavailable ? (
                                <button
                                    className="mg-btn is-white is-xsmall mg-margin-r-10"
                                    onClick={this.handleOpenInSerpchecker}
                                    type="button"
                                >
                                    <img
                                        alt="Sch"
                                        className="mg-margin-r-5"
                                        src={serpcheckerIcon}
                                        style={{ marginTop: '-2px' }}
                                        width="9"
                                    />
                                    Open in SERPChecker
                                </button>
                            ) : null}
                            {previewUnavailable ? (
                                // A disabled button swallows mouse events, so the tooltip listens on a wrapping span.
                                <Tooltip overlayContent={<span>There&apos;s no SERP to download for this day.</span>}>
                                    <span className="uk-display-inline-block">
                                        <button className="mg-btn is-blue is-xsmall" disabled type="button">
                                            <FontAwesomeIcon icon="download" aria-hidden="true" />
                                            Download SERP
                                        </button>
                                    </span>
                                </Tooltip>
                            ) : (
                                <button
                                    className="mg-btn is-blue is-xsmall"
                                    disabled={this.props.fetchingSnapshot}
                                    onClick={this.handleSaveImage}
                                    type="button"
                                >
                                    <FontAwesomeIcon icon="download" aria-hidden="true" />
                                    {this.props.fetchingSnapshot ? 'Fetching...' : 'Download SERP'}
                                </button>
                            )}
                            {this.props.serpCrawledDate && !previewUnavailable && (
                                <div
                                    style={{
                                        color: '#c0c0c0',
                                        fontSize: '8px',
                                        textAlign: 'center',
                                        position: 'absolute',
                                        bottom: '2px',
                                        lineHeight: '8px',
                                        left: '2px'
                                    }}
                                >
                                    {this.props.serpCrawledDate}
                                </div>
                            )}
                            {this.props.serpSrc && (
                                // Staff only (the API sends src to admin and support): which
                                // provider fetched this page and the URL we asked it for
                                // (ITRBU-669).
                                <div
                                    style={{
                                        color: '#c0c0c0',
                                        fontSize: '8px',
                                        lineHeight: '10px',
                                        textAlign: 'left',
                                        wordBreak: 'break-all',
                                        marginTop: '6px',
                                    }}
                                >
                                    {this.props.serpSrc.provider}
                                    {this.props.serpSrc.u ? ` · ${this.props.serpSrc.u}` : ''}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }
}

SerpModal.propTypes = {
    keyword: string.isRequired,
    locationId: number,
    onClose: func.isRequired,
    platformId: number,
    visible: bool.isRequired,
    requestSnapshotImage: func.isRequired,
    serpUrl: string.isRequired,
    fetchingSnapshot: bool.isRequired,
    serpCrawledDate: string,
    serpExpired: bool.isRequired,
    colorScheme: string.isRequired,
    previewDate: string.isRequired,
    serpSrc: object, // eslint-disable-line react/forbid-prop-types
};

export default SerpModal;
